import i18nInst from 'src/i18n';
import {
  convertUserGroup,
  disableCheckboxAllTargetGroup,
  getAllTargetsDisplay,
} from 'src/pages/Policy/utils/fns';
import { TargetUser } from 'src/pages/Policy/utils/types';

import { PolicyStore } from './createStore';
import { TreeNode } from 'src/components/Tree/type';
import cloneDeep from 'lodash/cloneDeep';

import { PolicyTypeEnum } from 'src/pages/Policy/utils/constants';
import { Service } from '@Types/app';

export const isPaginationSelector = (s: PolicyStore) => {
  const {
    availableTargets: { pagination },
  } = s;
  return !!pagination;
};
export const allTargetDomainsSelector = (s: PolicyStore) => {
  const { t } = i18nInst;
  const availableTargetDomains = s.availableTargetDomains;
  const policy = s.template;
  const policyType = policy.policyType;
  let serviceType = Service.ExchangeInline;
  switch (policyType) {
    case PolicyTypeEnum.ExchangeInline:
      serviceType = Service.ExchangeInline;
      break;
    case PolicyTypeEnum.GmailInline:
      serviceType = Service.GmailInline;
      break;
    default:
      break;
  }
  const { targets } = availableTargetDomains;
  let domains: TreeNode[] = [];
  if (targets) {
    domains = targets.map((item: TargetUser) => ({
      ...item,
      icon: 'user',
    }));
  }

  // add show more node
  const isPagination = !!availableTargetDomains.pagination;
  const getMoreTargetDomains = () =>
    s.getAllTargetDomainsBase(false, serviceType);
  const domainsWithShowMore = getAllTargetsDisplay(
    domains,
    isPagination,
    getMoreTargetDomains
  );
  // add All domains node
  const newAvailableTargetsGerneral = [
    {
      title: t(`policy.policyTarget.allDomains`),
      key: 'all',
      children: domainsWithShowMore,
      expanded: true,
    },
  ];
  return newAvailableTargetsGerneral;
};

export const availableTargetsGeneralInlineSelector = (s: PolicyStore) => {
  const availableTargetsGeneral = cloneDeep(s.availableTargetsGerneral);
  const availableTargetsGenralInline = disableCheckboxAllTargetGroup(
    availableTargetsGeneral
  );
  return availableTargetsGenralInline;
};

export const availableTargetsGeneralTeamsSelector = (s: PolicyStore) => {
  const availableTargetsGeneralTeams = cloneDeep(s.availableTargetsGerneral);
  // remove the children property, so that tree will not show expand icon
  // because teams only have group no user, the group cannot be expanded
  if (availableTargetsGeneralTeams.length) {
    availableTargetsGeneralTeams[0].children?.forEach((item) => {
      item.children = undefined;
    });
  }
  return availableTargetsGeneralTeams;
};

export const allTargetProfilesSelector = (s: PolicyStore) => {
  const { t } = i18nInst;
  const availableTargetProfiles = s.availableTargetProfiles;
  const { targets } = availableTargetProfiles;
  let profiles: TreeNode[] = [];
  if (targets) {
    profiles = targets.map((item: TargetUser) => ({
      ...item,
      icon: 'user',
    }));
  }
  const policy = s.template;
  const policyType = policy.policyType;
  let serviceType = Service.SalesforceSandbox;
  switch (policyType) {
    case PolicyTypeEnum.SalesforceSandbox:
      serviceType = Service.SalesforceSandbox;
      break;
    case PolicyTypeEnum.SalesforceProduction:
      serviceType = Service.SalesforceProduction;
      break;
    default:
      break;
  }
  // add show more node
  const isPagination = !!availableTargetProfiles.pagination;
  const getMoreTargetProfiles = () =>
    s.getAllProfilesTargetsByService(false, serviceType);
  const profilesWithShowMore = getAllTargetsDisplay(
    profiles,
    isPagination,
    getMoreTargetProfiles
  );
  // add All profiles node
  const newAvailableTargetsGerneral = [
    {
      title: t(`policy.policyTarget.salesforceSandbox.allProfile`),
      key: 'all',
      children: profilesWithShowMore,
      expanded: true,
    },
  ];
  return newAvailableTargetsGerneral;
};

export const allTargetObjectsSelector = (s: PolicyStore) => {
  const { t } = i18nInst;
  const policy = s.template;
  const policyType = policy.policyType;
  let serviceType = Service.SalesforceSandbox;
  switch (policyType) {
    case PolicyTypeEnum.SalesforceSandbox:
      serviceType = Service.SalesforceSandbox;
      break;
    case PolicyTypeEnum.SalesforceProduction:
      serviceType = Service.SalesforceProduction;
      break;
    default:
      break;
  }
  const availableTargetObjects = s.availableTargetObjects;
  const objects: TreeNode[] = convertUserGroup(
    availableTargetObjects.targets ? availableTargetObjects.targets : [],
    availableTargetObjects.targetGroups
      ? availableTargetObjects.targetGroups
      : [],
    policyType
  );
  // add show more node
  const isObjectsPagination = !!availableTargetObjects.pagination;
  const getMoreTargetObjects = () =>
    s.getAllObjectsTargetsByService(false, serviceType);
  const objectsTargetsWithShowMore = getAllTargetsDisplay(
    objects,
    isObjectsPagination,
    getMoreTargetObjects
  );

  const newAvailableTargetsGerneral = [
    {
      title: t(`policy.policyTarget.salesforceSandbox.dlp.allObjects`),
      key: 'all',
      children: objectsTargetsWithShowMore,
      expanded: true,
    },
  ];
  return newAvailableTargetsGerneral;
};

export const allTargetAppsSelector = (s: PolicyStore) => {
  const { t } = i18nInst;

  const newAvailableTargets = [
    ...(s.availableTargetObjectsGeneral[0]?.children || []),
  ];

  const newAvailableTargetsGerneral = [
    {
      title: t(`policy.policyTarget.salesforceSandbox.allApps`),
      key: 'all',
      children: newAvailableTargets,
      expanded: true,
    },
  ];
  return newAvailableTargetsGerneral;
};
